export default __webpack_public_path__ + "static/media/vantagens.1759bde4.png";